/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import { Box, Typography, Paper } from "@mui/material";

const McqQuestion = ({question,currentIndex,questionNumber = 1,selectedAnswer,onSelect}) => {
  let parsedOptions = [];

  try {
    const parsed =
      typeof question?.options === "string"
        ? JSON.parse(question.options)
        : question.options;

    parsedOptions = parsed?.mcqOptions || parsed || [];
  } catch {
    parsedOptions = [];
  }

  return (
    <Box
      sx={{
        p: "16px 20px !important",
        // backgroundColor: "#f0f2f5",
        minHeight: "70%",
        maxHeight : "70%",
      }}
    >
       <div style={{display: "flex",alignItems: "center",gap: "12px",marginBottom: "16px", fontFamily: "system-ui, -apple-system, sans-serif"}} >
      <span style={{fontSize: "17px",fontWeight: 700,color: "#111827",letterSpacing: "-0.01em"}}>Question {currentIndex + 1}</span>
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "6px",
            border: "1px solid #FCD9BD",
            backgroundColor: "#FFF8F1",
            color: "#B54708",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.04em",
          }}
        >
          SINGLE CORRECT
        </span>

     
    </div>
    <Paper elevation={0} sx={{p: "12px 16px",borderRadius: "12px",backgroundColor: "#ffffff",border: "1px solid #e5e7eb",mb: 1}}>
  <Typography dangerouslySetInnerHTML={{ __html: question?.question_text}} sx={{fontSize: 15,color: "#111827",lineHeight: 1.7,fontWeight: 400,textAlign:"left",}}/>
</Paper>
      {/* <Paper
        elevation={0}
        sx={{
          p: "12px 16px",
          borderRadius: "12px",
          backgroundColor: "#ffffff",
          border: "1px solid #e5e7eb",
          mb: 1,
        }}
      >
        <Typography
          dangerouslySetInnerHTML={{
            __html: question?.question_text,
          }}
          sx={{
            fontSize: 15,
            color: "#111827",
            lineHeight: 1.7,
            fontWeight: 400,
          }}
        />
      </Paper> */}

      {parsedOptions.map((option, index) => {
        const optionLetter = String.fromCharCode(65 + index);
        const isSelected = selectedAnswer === option;

        return (
          <Paper
            key={index}
            elevation={0}
            onClick={() => onSelect(option)}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2, py: 0.7, mb: 0.6,
              borderRadius: "12px",
              cursor: "pointer",
              border: isSelected ? "1.5px solid #3b82f6" : "1.5px solid #e5e7eb",
              backgroundColor: isSelected ? "#eff6ff" : "#ffffff",
              transition: "all 0.15s ease",
              "&:hover": {
                borderColor: isSelected ? "#3b82f6" : "#c7d2e8",
                backgroundColor: isSelected ? "#eff6ff" : "#f9fafb",
              },
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: isSelected ? "#dbeafe" : "#f3f4f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 12,
                color: isSelected ? "#2563eb" : "#374151",
                mr: 2.5,
                flexShrink: 0,
              }}
            >
              {optionLetter}
            </Box>

            <Typography sx={{fontSize: 14.5,color: "#1f2937",fontWeight: isSelected ? 500 : 400,lineHeight: 1.5,}} dangerouslySetInnerHTML={{ __html: option }}/>
          </Paper>
        );
      })}
    </Box>
  );
};

export default McqQuestion;